// extracted by mini-css-extract-plugin
export default {"content":"W2fHZD_G","subtitle":"lhXcb2bG","editorial":"iwsAVdDj"};